<template>
  <div class="player-controls flex items-center h-100 p1-ns f5">
    <button @click="playPrevious" class="pa2" :disabled="!canPrevious || isUnauthorized" title="Anterior">
      <font-awesome-icon class="iconColor" icon="step-backward"/>
    </button>
    <button v-show="isPlaying" @click="setPlaying(false)" class="pa2" :disabled="isUnauthorized" title="Pausa">
      <font-awesome-icon class="iconColor" icon="pause"/>
    </button>
    <button v-show="!isPlaying" @click="setPlaying(true)" class="pa2" :disabled="isUnauthorized" title="Play">
      <font-awesome-icon class="iconColor" icon="play"/>
    </button>
    <button @click="playNext" class="pa2" :disabled="!canNext || isUnauthorized" title="Siguiente">
      <font-awesome-icon class="iconColor" icon="step-forward"/>
    </button>
    <div @mouseover="volumeOpen=true" @mouseout="volumeOpen=false" class="dn flex-ns flex-column w2" :class="{'h5': volumeOpen}">
      <div v-show="volumeOpen" class="slider-container relative bg-secondary relative flex items-center">
        <input v-model="volume" class="slider absolute" type="range" min="0" max="1" step="0.1">
      </div>
      <button @click="volumeTrigger()" class="w-100 dialog db-ns pa2" title="Volumen">
        <font-awesome-icon class="iconColor" :icon="mute ? 'volume-off' : (volume > 0.5 ? 'volume-up' : 'volume-down')"/>
      </button>
    </div>
  </div>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'player-controls',
    data () {
      return {
        volume: 1,
        mute: false,
        volumeOpen: false
      }
    },
    components: {
      FontAwesomeIcon
    },
    methods: {
      ...mapActions('player', [
        'setPlaying',
        'playNext',
        'playPrevious'
      ]),
      volumeTrigger () {
        this.mute = !this.mute
        this.$emit('mute', this.mute)
      }
    },
    computed: {
      ...mapGetters('player', [
        'isPlaying',
        'canPrevious',
        'canNext',
        'isUnauthorized'
      ])
    },
    watch: {
      volume () {
        this.$emit('changeVolume', this.volume)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .player-controls {
    flex-grow: 0;
    button {
      border: none;
      background: none;
      margin: 0;
      cursor: pointer;
    }
    button:disabled .iconColor{
      color: #7b7a7b;
    }
  }

  .slider-container {
    height: 7rem;
    border-color: #7b7a7b;
  }

  .slider {
    transform: rotate(270deg);
    -webkit-appearance: none;
    width: 100px;
    height: 5px;
    border-radius: 5px;
    border-width: 0;
    background-color: #7b7a7b;
    outline: none;
    -webkit-transition: .2s;
    transition: opacity .2s;
    left: -35px;
    padding: 0;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border-width: 0;
    background: $primary-color;
    cursor: pointer;
  }

  .slider::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border-width: 0;
    background: $primary-color;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/player/PlayerControls.vue